import * as React from 'react';
import classnames from 'classnames';
import { ISubWindowLayoutProps, ISubWindowMinimizedLayoutProps } from '../../../../infrastructure/sub-windows';
import { SubWindowContext, SubWindowState } from '../sub-window.viewmodel';
import { CollapseIcon, ExpandIcon, MaximizeIcon, MinimizeIcon } from '../../icons/icons';
import './common-sub-window.scss';
import Text from '../../text/text';
import { CrossCloseSubWindowIcon } from './common-close-sub-window-buttons';

/**
 * common maximized sub-window layout, utilize `oe-popup-layout` block styles
 * @param props
 * @constructor
 */
const CommonSubWindowMinimized = (props: ISubWindowMinimizedLayoutProps) => {
    const handleHeaderClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, context) => {
        if (props.isExpandedByDefault) {
            context.changeState(SubWindowState.EXPANDED);
        } else {
            context.changeState(SubWindowState.MAXIMIZED);
        }
    };

    const handleClickExpand = (e, context) => {
        e.stopPropagation();
        if (props.isExpandedByDefault) {
            context.changeState(SubWindowState.EXPANDED);
        } else {
            context.changeState(SubWindowState.MAXIMIZED);
        }
    };

    return (
        <SubWindowContext.Consumer>
            {
                context => (
                    <div className='oe-popup-layout oe-popup-layout--sub-window-minimized'>
                        <div className='oe-popup-layout__header' onClick={e => handleHeaderClick(e, context)}>
                            <Text className='oe-popup-layout__header-title' message={props.title} withEllipsis/>
                            <div className='oe-popup-layout__controls'>
                                <MaximizeIcon onClick={e => handleClickExpand(e, context)} />
                                <CrossCloseSubWindowIcon />
                            </div>
                        </div>
                    </div>
                )
            }
        </SubWindowContext.Consumer>
    );
};

/**
 * common minimized sub-window layout, utilize `oe-popup-layout` block styles
 * @param props
 * @constructor
 */
const CommonSubWindow = (props: ISubWindowLayoutProps) => {
    const { title, children, withExpand, isExpanded, additionalTitle, subWindowClassname } = props;

    const handleChangeState = (context, toExpanded = false) => {
        context.changeState(toExpanded ? SubWindowState.EXPANDED : SubWindowState.MAXIMIZED);
    };

    return (
        <SubWindowContext.Consumer>
            {
                context => (
                    <div className={classnames(`oe-popup-layout ${subWindowClassname || ''}`, {
                        'oe-popup-layout--sub-window-maximized': !isExpanded,
                        'oe-popup-layout--sub-window-expanded': isExpanded
                    })}>
                        <div className='oe-popup-layout__header'>
                            <CrossCloseSubWindowIcon />
                            <MinimizeIcon onClick={() => context.changeState(SubWindowState.MINIMIZED)} />
                            { withExpand && !isExpanded && <ExpandIcon onClick={() => handleChangeState(context, true)} /> }
                            { withExpand && isExpanded && <CollapseIcon onClick={() => handleChangeState(context)} /> }
                            <div className='oe-popup-layout__header-title-block'>
                                <div className='oe-popup-layout__header-title'>
                                    {title}
                                </div>
                                {additionalTitle && isExpanded &&
                                    <div className='oe-popup-layout__header-title text-ellipsis'>
                                        {additionalTitle}
                                    </div>
                                }
                            </div>
                        </div>
                        {children}
                    </div>
                )
            }
        </SubWindowContext.Consumer>
    );
};

export { CommonSubWindow, CommonSubWindowMinimized };
